import { render, staticRenderFns } from "./MaterialSelectCountries.vue?vue&type=template&id=6897bfc2&scoped=true&lang=pug&"
import script from "./MaterialSelectCountries.vue?vue&type=script&lang=ts&"
export * from "./MaterialSelectCountries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6897bfc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
